import type { UserLevel } from '@/types/site';

export const userLevelToKr = (userLevel: UserLevel) => {
  switch (userLevel) {
    case 'AGENCY_MANAGER':
      return '대리점 관리자';
    case 'PUBLIC_OFFICE_MANAGER':
      return '관공서 관리자';
    case 'TOWN_MANAGER':
      return '마을 관리자';
  }
};
